import api from './api';

/** Server analytics (Amplitude) status: key, requests since server start, calendar facts journal. */
export interface AnalyticsStatus {
  enabled: boolean;
  transport: {
    sentRequests: number;
    failedRequests: number;
    lastSuccessAt: string | null;
    lastFailure: { at: string; context: string; message: string } | null;
  };
  journal: {
    last24h: { sent: number; marked: number };
    total: { sent: number; marked: number };
  };
}

export interface AnalyticsTestResult {
  enabled: boolean;
  userId: string;
  eventSent: boolean;
  propertiesSent: boolean;
}

export interface SignupDateBackfillResult {
  enabled: boolean;
  users: number;
}

export async function getAnalyticsStatus(): Promise<AnalyticsStatus> {
  const response = await api.get('/developer/analytics/status');
  return response.data.data;
}

/** Sends analytics_test_event and server user properties for the current developer. */
export async function sendAnalyticsTestEvent(): Promise<AnalyticsTestResult> {
  const response = await api.post('/developer/analytics/test-event');
  return response.data.data;
}

/** One-off: signup_date for all existing clients. Safe to repeat. */
export async function backfillSignupDate(): Promise<SignupDateBackfillResult> {
  const response = await api.post('/developer/analytics/backfill-signup-date');
  return response.data.data;
}
